export default "__VITE_ASSET__tKumEV5O__"